import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20product%20display%20scene%20with%20warm%20cream%20and%20sand%20beige%20background%2C%20elegant%20flat%20lay%20arrangement%20of%20modern%20fashion%20lifestyle%20items%20including%20a%20neatly%20folded%20oatmeal%20knit%20sweater%2C%20classic%20cream%20low-top%20sneakers%2C%20a%20simple%20taupe%20cap%2C%20a%20minimalist%20leather%20watch%2C%20and%20a%20small%20ceramic%20vase%20with%20dried%20pampas%20grass%20arranged%20on%20a%20light%20oak%20surface%2C%20soft%20natural%20daylight%20streaming%20from%20the%20left%2C%20airy%20and%20clean%20aesthetic%2C%20editorial%20catalog%20photography%20style%20with%20gentle%20shadows%2C%20high%20key%20lighting%2C%20warm%20neutral%20tone%2C%20calm%20organized%20composition&width=1800&height=1000&seq=hero-bg-vigorbuy-v2&orientation=landscape"
          alt="VigorBuy Spreadsheet - Product discovery and shopping resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400"></div>
            <span className="text-xs md:text-sm font-label text-background-50">Updated 2026 Resources</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            VigorBuy Spreadsheet
            <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 text-background-50/90">
              The Ultimate Product Discovery &amp; Shopping Guide
            </span>
          </h1>

          <p className="text-sm md:text-base text-background-50/85 max-w-xl mx-auto mb-8 leading-relaxed">
            Discover the latest VigorBuy Spreadsheet collections, organized product lists, quality checking guides, comparison tools, and expert shopping resources — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-label font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer no-underline"
            >
              VigorBuy Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm md:text-base font-label font-semibold border-2 border-background-50 text-background-50 rounded-full hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer no-underline"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8">
            <div className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-accent-400"></i>
              </div>
              Updated Resources
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-accent-400"></i>
              </div>
              Beginner Friendly
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-accent-400"></i>
              </div>
              Organized Categories
            </div>
            <div className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-check-line text-accent-400"></i>
              </div>
              Shopping Safety Tips
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-8 h-8 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}